interface Identifier {
  end: number
  name: string
  start: number
}

interface RefactorOptions {
  trim?: boolean
}

export function refactor(
  code?: string,
  identifiers?: Identifier[],
  options?: RefactorOptions
) {
  if (!code || !identifiers?.length) return code
  if (options?.trim) code = code.trim()
  identifiers
    .toSorted((a, b) => b.start - a.start)
    .forEach(({ end, name, start }) => {
      const oldName = code?.slice(start, end)
      if (code && oldName && oldName !== name) {
        code = `${code.slice(0, start)}${name}${code.slice(end)}`
      }
    })
  return code
}
